import { render, staticRenderFns } from "./NewFileRequestDialogDatePassword.vue?vue&type=template&id=1b164b40&scoped=true"
import script from "./NewFileRequestDialogDatePassword.vue?vue&type=script&lang=ts"
export * from "./NewFileRequestDialogDatePassword.vue?vue&type=script&lang=ts"
import style0 from "./NewFileRequestDialogDatePassword.vue?vue&type=style&index=0&id=1b164b40&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b164b40",
  null
  
)

export default component.exports